function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.27 5a7.92 7.92 0 00-7.91 7.91 7.82 7.82 0 001.72 4.91l-1 1a2.66 2.66 0 00-2.94.5l-3.33 3.32a2.61 2.61 0 103.69 3.69l3.35-3.34a2.61 2.61 0 00.6-2.72l1.06-1.05A7.91 7.91 0 1019.27 5zm-7.84 16.57l-3.35 3.35a.61.61 0 01-.86-.83l3.35-3.35a.6.6 0 01.43-.18.58.58 0 01.43.18.6.6 0 010 .83zm7.84-2.74a5.92 5.92 0 110-11.84 5.92 5.92 0 010 11.84z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcSearchAndGeocoding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcSearchAndGeocoding;